module.exports = __webpack_public_path__ + "static/media/Classic T Guitar Match off VR.877370b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Classic T Guitar Match off VR.mp3
// module id = P2YV
// module chunks = 13